import { Box } from '../Layout';
import { styled } from '../../themeCustomink';
var StickyActionBarMobile = styled(Box, {
    shouldForwardProp: function (key) {
        return !['showDownFrom', 'hideOtherwise'].includes(key);
    },
})(function (_a) {
    var _b;
    var theme = _a.theme, _c = _a.showDownFrom, showDownFrom = _c === void 0 ? 'md' : _c, _d = _a.hideOtherwise, hideOtherwise = _d === void 0 ? false : _d;
    return (_b = {},
        _b[theme.breakpoints.down(showDownFrom)] = {
            bottom: 0,
            backgroundColor: theme.palette.background.paper,
            boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.25)',
            left: 0,
            padding: '0.75rem 1rem',
            position: 'fixed',
            width: '100%',
            zIndex: 2,
            boxSizing: 'border-box',
        },
        _b[theme.breakpoints.up(showDownFrom)] = {
            display: hideOtherwise ? 'none' : undefined,
        },
        _b);
});
export default StickyActionBarMobile;
//# sourceMappingURL=StickyActionBarMobile.js.map